module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "grey lighten-4 elevation-0"
  }, [(!_vm.fatalError) ? _c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(!_vm.submited) ? _c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-subheader', [_vm._v("Informações do trabalho")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "item-text": "name",
      "item-value": "id",
      "label": "Curso",
      "data-vv-as": "Curso",
      "data-vv-name": "exam.course",
      "prepend-icon": "class",
      "required": "",
      "errors": _vm.vErrors.collect('exam.course'),
      "disabled": _vm.isEdition,
      "no-data-text": _vm.noDataText,
      "items": _vm.userCourses
    },
    on: {
      "change": _vm.getExamTypes
    },
    model: {
      value: (_vm.exam.course),
      callback: function($$v) {
        _vm.$set(_vm.exam, "course", $$v)
      },
      expression: "exam.course"
    }
  }), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "errors": _vm.vErrors.collect('exam.type'),
      "disabled": _vm.studentChecked,
      "no-data-text": _vm.noDataText,
      "items": _vm.nCourseTypes,
      "label": "Tipo",
      "data-vv-as": "Tipo",
      "data-vv-name": "exam.type",
      "prepend-icon": "create",
      "item-text": "name",
      "item-value": "id",
      "required": ""
    },
    model: {
      value: (_vm.exam.type),
      callback: function($$v) {
        _vm.$set(_vm.exam, "type", $$v)
      },
      expression: "exam.type"
    }
  }), _vm._v(" "), [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "label": "Título",
      "data-vv-as": "Título",
      "data-vv-name": "exam.title",
      "errors": _vm.vErrors.collect('exam.title'),
      "readonly": _vm.readonly,
      "prepend-icon": "title"
    },
    model: {
      value: (_vm.exam.title),
      callback: function($$v) {
        _vm.$set(_vm.exam, "title", $$v)
      },
      expression: "exam.title"
    }
  })]], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-subheader', [_vm._v("Banca Semestre")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.semesters,
      "item-text": "name",
      "item-value": "id",
      "label": "Semestre",
      "prepend-icon": "date_range",
      "data-vv-name": "Semestre",
      "errors": _vm.vErrors.collect('Semestre'),
      "required": ""
    },
    model: {
      value: (_vm.exam.semesters),
      callback: function($$v) {
        _vm.$set(_vm.exam, "semesters", $$v)
      },
      expression: "exam.semesters"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-subheader', [_vm._v("Identificação do aluno")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [(!_vm.isEdition) ? _c('v-btn', {
    staticClass: "green",
    attrs: {
      "dark": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.exam.student.push('')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" Adicionar Aluno\n            ")], 1) : _vm._e(), _vm._v(" "), (false) ? _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Aluno",
      "prepend-icon": "person",
      "data-vv-as": "Aluno",
      "data-vv-name": "exam.student",
      "errors": _vm.vErrors.collect('exam.student'),
      "required": "",
      "autocomplete": "",
      "disabled": !_vm.exam.course,
      "loading": _vm.studentLoading,
      "no-data-text": _vm.noDataText,
      "items": _vm.students,
      "search-input": _vm.searchStudentVal,
      "item-text": "name_and_id",
      "item-value": "id"
    },
    on: {
      "update:searchInput": function($event) {
        _vm.searchStudentVal = $event
      },
      "update:search-input": function($event) {
        _vm.searchStudentVal = $event
      }
    },
    model: {
      value: (_vm.exam.student),
      callback: function($$v) {
        _vm.$set(_vm.exam, "student", $$v)
      },
      expression: "exam.student"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.exam.student), function(student, idx) {
    return [(!_vm.isEdition) ? _c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm11": ""
      }
    }, [_c('v-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "label": 'Aluno ' + (idx + 1),
        "prepend-icon": "person",
        "data-vv-as": "Aluno",
        "data-vv-name": "exam.student",
        "errors": _vm.vErrors.collect('exam.student'),
        "required": "",
        "autocomplete": "",
        "disabled": !_vm.exam.course,
        "loading": _vm.studentLoading,
        "no-data-text": _vm.noDataText,
        "rules": [function (v) { return !!v || 'O Aluno ' + (idx + 1) + ' precisa ser informado'; }],
        "items": _vm.students,
        "search-input": _vm.searchStudentVal,
        "item-text": "name_and_id",
        "item-value": "id"
      },
      on: {
        "update:searchInput": function($event) {
          _vm.searchStudentVal = $event
        },
        "update:search-input": function($event) {
          _vm.searchStudentVal = $event
        }
      },
      model: {
        value: (_vm.exam.student[idx]),
        callback: function($$v) {
          _vm.$set(_vm.exam.student, idx, $$v)
        },
        expression: "exam.student[idx]"
      }
    })], 1), _vm._v(" "), (!_vm.readonly) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm1": ""
      }
    }, [_c('v-btn', {
      staticClass: "red",
      attrs: {
        "fab": "",
        "dark": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.exam.student.splice(idx, 1)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("remove")])], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isEdition) ? _c('v-layout', [(_vm.isEdition) ? _c('v-text-field', {
      attrs: {
        "label": "Aluno",
        "readonly": "",
        "prepend-icon": "subject"
      },
      model: {
        value: (_vm.exam.studentName[idx]),
        callback: function($$v) {
          _vm.$set(_vm.exam.studentName, idx, $$v)
        },
        expression: "exam.studentName[idx]"
      }
    }) : _vm._e()], 1) : _vm._e()]
  })], 2)], 1), _vm._v(" "), (true) ? [_c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-subheader', [_vm._v("Informações da sessão")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": true,
      "transition": "v-scale-transition",
      "offset-y": "",
      "nudge-left": 40
    },
    model: {
      value: (_vm.menuReleaseDate),
      callback: function($$v) {
        _vm.menuReleaseDate = $$v
      },
      expression: "menuReleaseDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Data de divulgação",
      "data-vv-as": "Data de divulgação",
      "data-vv-name": "exam.release_date",
      "errors": _vm.vErrors.collect('exam.release_date'),
      "readonly": "",
      "prepend-icon": "date_range"
    },
    slot: "activator",
    model: {
      value: (_vm.formattedReleaseDate),
      callback: function($$v) {
        _vm.formattedReleaseDate = $$v
      },
      expression: "formattedReleaseDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "locale": "pt-BR"
    },
    model: {
      value: (_vm.exam.release_date),
      callback: function($$v) {
        _vm.$set(_vm.exam, "release_date", $$v)
      },
      expression: "exam.release_date"
    }
  })], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": true,
      "transition": "v-scale-transition",
      "offset-y": "",
      "nudge-left": 40,
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.menuDate),
      callback: function($$v) {
        _vm.menuDate = $$v
      },
      expression: "menuDate"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "slot": "activator",
      "label": "Data",
      "data-vv-as": "Data",
      "data-vv-name": "exam.date",
      "errors": _vm.vErrors.collect('exam.date'),
      "required": "",
      "readonly": "",
      "prepend-icon": "date_range"
    },
    slot: "activator",
    model: {
      value: (_vm.formattedDate),
      callback: function($$v) {
        _vm.formattedDate = $$v
      },
      expression: "formattedDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "locale": "pt-BR"
    },
    model: {
      value: (_vm.exam.date),
      callback: function($$v) {
        _vm.$set(_vm.exam, "date", $$v)
      },
      expression: "exam.date"
    }
  })], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "v-scale-transition",
      "offset-y": "",
      "nudge-left": 40,
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.menuTime),
      callback: function($$v) {
        _vm.menuTime = $$v
      },
      expression: "menuTime"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "slot": "activator",
      "label": "Hora",
      "data-vv-as": "Hora",
      "data-vv-name": "exam.hour",
      "errors": _vm.vErrors.collect('exam.hour'),
      "required": "",
      "readonly": "",
      "prepend-icon": "access_time"
    },
    slot: "activator",
    model: {
      value: (_vm.exam.hour),
      callback: function($$v) {
        _vm.$set(_vm.exam, "hour", $$v)
      },
      expression: "exam.hour"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "format": "24hr"
    },
    model: {
      value: (_vm.exam.hour),
      callback: function($$v) {
        _vm.$set(_vm.exam, "hour", $$v)
      },
      expression: "exam.hour"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Local",
      "data-vv-as": "Local",
      "data-vv-name": "exam.place",
      "errors": _vm.vErrors.collect('exam.place'),
      "required": "",
      "prepend-icon": "edit_location",
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.exam.place),
      callback: function($$v) {
        _vm.$set(_vm.exam, "place", $$v)
      },
      expression: "exam.place"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Vagas",
      "data-vv-as": "Vagas",
      "data-vv-name": "exam.vacancies",
      "errors": _vm.vErrors.collect('exam.vacancies'),
      "prepend-icon": "persons"
    },
    model: {
      value: (_vm.exam.vacancies),
      callback: function($$v) {
        _vm.$set(_vm.exam, "vacancies", $$v)
      },
      expression: "exam.vacancies"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-subheader', [_vm._v("Composição da banca")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Orientador",
      "data-vv-as": "Orientador",
      "data-vv-name": "exam.advisor",
      "errors": _vm.vErrors.collect('exam.chair'),
      "required": "",
      "autocomplete": "",
      "prepend-icon": "person",
      "readonly": _vm.readonly,
      "no-data-text": _vm.noDataText,
      "items": _vm.teachersComputed,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.exam.advisor),
      callback: function($$v) {
        _vm.$set(_vm.exam, "advisor", $$v)
      },
      expression: "exam.advisor"
    }
  }), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Presidente",
      "data-vv-as": "Presidente",
      "data-vv-name": "exam.chair",
      "errors": _vm.vErrors.collect('exam.chair'),
      "required": "",
      "autocomplete": "",
      "prepend-icon": "person",
      "readonly": _vm.readonly,
      "no-data-text": _vm.noDataText,
      "items": _vm.teachersComputed,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.exam.chair),
      callback: function($$v) {
        _vm.$set(_vm.exam, "chair", $$v)
      },
      expression: "exam.chair"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.chairIsExaminer),
      callback: function($$v) {
        _vm.chairIsExaminer = $$v
      },
      expression: "chairIsExaminer"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("O presidente também é examinador")])]), _vm._v(" "), _vm._l((_vm.exam.examiners), function(examiner, idx) {
    return [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm11": ""
      }
    }, [_c('v-select', {
      attrs: {
        "label": 'Examinador ' + (idx + 1),
        "prepend-icon": "person",
        "rules": [function (v) { return !!v || 'O examinador ' + (idx + 1) + ' precisa ser informado'; }],
        "required": "",
        "autocomplete": "",
        "readonly": _vm.readonly,
        "items": _vm.teachersComputed,
        "item-text": "name",
        "item-value": "id"
      },
      model: {
        value: (_vm.exam.examiners[idx]),
        callback: function($$v) {
          _vm.$set(_vm.exam.examiners, idx, $$v)
        },
        expression: "exam.examiners[idx]"
      }
    })], 1), _vm._v(" "), (!_vm.readonly) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm1": ""
      }
    }, [_c('v-btn', {
      staticClass: "red",
      attrs: {
        "fab": "",
        "dark": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.exam.examiners.splice(idx, 1)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("remove")])], 1)], 1) : _vm._e()], 1)]
  }), _vm._v(" "), (!_vm.readonly) ? _c('v-layout', {
    staticClass: "mb-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('v-btn', {
    staticClass: "green",
    attrs: {
      "dark": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.exam.examiners.push('')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" Adicionar examinador\n                  ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.exam.substitutes), function(substitute, idx) {
    return [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm11": ""
      }
    }, [_c('v-select', {
      attrs: {
        "label": 'Suplente ' + (idx + 1),
        "no-data-text": _vm.noDataText,
        "prepend-icon": "person",
        "rules": [function (v) { return !!v || 'O suplente ' + (idx + 1) + ' precisa ser informado'; }],
        "required": "",
        "autocomplete": "",
        "readonly": _vm.readonly,
        "items": _vm.teachers,
        "item-text": "name",
        "item-value": "id"
      },
      model: {
        value: (_vm.exam.substitutes[idx]),
        callback: function($$v) {
          _vm.$set(_vm.exam.substitutes, idx, $$v)
        },
        expression: "exam.substitutes[idx]"
      }
    })], 1), _vm._v(" "), (!_vm.readonly) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm1": ""
      }
    }, [_c('v-btn', {
      staticClass: "red",
      attrs: {
        "fab": "",
        "dark": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.exam.substitutes.splice(idx, 1)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("remove")])], 1)], 1) : _vm._e()], 1)]
  }), _vm._v(" "), (!_vm.readonly) ? _c('v-layout', {
    staticClass: "mb-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('v-btn', {
    staticClass: "green",
    attrs: {
      "dark": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.exam.substitutes.push('')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" Adicionar suplente\n                  ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('v-layout', {
    staticClass: "mb-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('v-btn', {
    staticClass: "green",
    attrs: {
      "dark": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.externalExaminerDialog = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("person_add")]), _vm._v(" Cadastrar avaliador externo\n                  ")], 1)], 1)], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "info": "",
      "value": _vm.vErrors.any()
    }
  }, [_vm._v("\n                Algum campo não foi preenchido corretamente. Revise o preenchimento dos dados para continuar.\n                " + _vm._s(_vm.vErrors.all()) + "\n              ")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "error": "",
      "value": _vm.submitErrors
    }
  }, [_vm._v("\n                Ocorreram os seguintes erros na submissão do formulário:\n                "), _c('ul', _vm._l((_vm.submitErrors), function(error) {
    return _c('li', [_vm._v(_vm._s(error))])
  }), 0)]), _vm._v(" "), (_vm.exam.finalScore == 0) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "success",
      "type": "submit",
      "disabled": _vm.vErrors.any()
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("done")]), _vm._v(" Confirmar\n              ")], 1) : _vm._e()], 1)], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.submited) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "green darken-1"
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v("Registro confirmado")])]), _vm._v(" "), _c('v-card-text', {
    attrs: {
      "height": "75px"
    }
  }, [_c('v-icon', {
    staticClass: "mr-4",
    attrs: {
      "dark": ""
    }
  }, [_vm._v("done")]), _vm._v("\n                O registro de planejamento de banca foi " + _vm._s(_vm.edit ? 'atualizado' : 'registrado') + " com sucesso no sistema sob o\n                  "), _c('v-chip', {
    staticClass: "green darken-1 white--text"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'examPlan',
        params: {
          id: _vm.exam.id
        }
      }
    }
  }, [_vm._v("n.º " + _vm._s(_vm.exam.id))])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "green darken-1",
    attrs: {
      "dark": "",
      "href": "/bancas/planejar"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("\n                  Planejar outra banca\n                ")])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.exam.finalScore > 0) ? _c('v-alert', {
    attrs: {
      "value": true,
      "error": ""
    }
  }, [_vm._v("Esta banca já teve a decisão final registrada.")]) : _vm._e(), _vm._v(" "), (_vm.fatalError) ? _c('v-alert', {
    attrs: {
      "value": true,
      "error": ""
    }
  }, [_vm._v("\n      Erro ao carregar dados.\n      "), (_vm.id > 0) ? [_vm._v("Certifique-se de que a banca " + _vm._s(_vm.id) + " existe e você tem acesso a ela.")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('fullscreen-spinner'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "lazy": ""
    },
    model: {
      value: (_vm.externalExaminerDialog),
      callback: function($$v) {
        _vm.externalExaminerDialog = $$v
      },
      expression: "externalExaminerDialog"
    }
  }, [_c('register-external-examiner', {
    on: {
      "registered": _vm.externalExaminerRegistered
    }
  }, [_c('template', {
    slot: "actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.externalExaminerDialog = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78373209"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExamPlan.vue
// module id = 253
// module chunks = 0